'use strict';

exports.__esModule = true;
var FIELDS = {
  EMAIL: 'Email',
  COUNTRY_CODE: 'CountryCode',
  MOBILE_NUMBER: 'Mobile',
  FIRST_NAME: 'FirstName',
  LAST_NAME: 'LastName',
  PASSWORD: 'Password'
};

exports.default = FIELDS;
module.exports = exports['default'];